export default __webpack_public_path__ + "static/branding5-f136859f19a9b65d30429a0991b9c53c.webp";